module.exports = __webpack_public_path__ + "static/media/chokha3.adcb70aa.webp";